import styled from 'styled-components'

export const DownloadCards = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;

  @media (min-width: 1024px) {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    row-gap: 24px;
    column-gap: 16px;
    margin: 24px 0 0 0;
  }
`

export const DownloadCard = styled.a`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  gap: 32px;
  cursor: pointer;
  padding: 16px;
  border-radius: 12px;
  border: 1px solid #DADADA;
  background: var(--gray-white, #FFF);

  &:hover {
    text-decoration: none;
  }
`

export const DownloadCardInfo = styled.div`
  display: flex;
  align-items: center;
`

export const DownloadCardInfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
`

export const FileName = styled.h2`
  display: -webkit-box;
    -webkit-line-clamp: 2; /* quantidade de linhas */
    -webkit-box-orient: vertical;
  color: #000;
  font-family: 'Open Sans';
  font-weight: 600;
  font-size: 16px;
  line-height: 120%;
  letter-spacing: 0.96px;
  margin-bottom: 4px;
  text-transform: capitalize;
  word-break: break-all;
  overflow: hidden;
  text-overflow: ellipsis;
`

export const FileInfo = styled.p`
  color: #555;
  white-space: pre-wrap;
  font-family: 'Open Sans';
  font-weight: 400;
  font-size: 13px;
  line-height: 19px;
  margin-bottom: 0px;
`
